<div class="modal-close" *ngIf="type != 'profile'" (click)="closeModal()">
  <fa-icon class="icon me-1" [icon]="faTimes"></fa-icon
  ><span>{{ "btn:close" | translate }}</span>
</div>
<app-loading-icon *ngIf="loading"></app-loading-icon>
<ng-container *ngIf="!loading">
  <div  
  *ngIf="this.video?.source?.exist">
  <app-video-player
  class="card-img-top"
  [video]="video"
  [autoPlay]="true"
></app-video-player>
  </div>

  <div *ngIf="!this.video?.source?.exist&&!loading" class="d-flex align-items-center justify-content-center"
  style="padding-bottom: 20.11%;padding-top: 20.11%;position: relative">
    <img src="assets/img/courses/video_not_found.png" alt="Imagen centrada" class="img-fluid" style="height: 400px;">
  </div>
</ng-container>
